<template>
  <div>
    <h2 class="subtitle">Products</h2>
    <product-item
      v-for="(product, index) in allProducts"
      :key="index"
      :product="product"
      @selected="onSelected"
    />
    <div :class="{ modal: true, 'is-active': alert }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <article class="message is-warning">
          <div class="message-header">
            <p>Warning</p>
            <button
              class="delete"
              @click="alert = ''"
              aria-label="delete"
            ></button>
          </div>
          <div class="message-body">
            {{ alert }}
          </div>
        </article>
      </div>
      <button
        class="modal-close is-large"
        @click="alert = ''"
        aria-label="close"
      ></button>
    </div>
    <div class="buttons is-justify-content-right">
      <button
        class="button is-warning"
        @click.prevent="updateSubsriptions()"
        href="#"
      >
        Confirm Selections
      </button>
    </div>
  </div>
</template>

<script>
import _get from "lodash/get";
import ProductItem from "./ProductItem";

export default {
  name: "products",
  components: {
    ProductItem,
  },

  data: () => ({
    selectedProducts: [],
    alert: "",
  }),
  computed: {},

  props: ["allProducts", "allSubscriptions", "plan", "nextChargeDate"],
  mounted() {
    // Set next charge date to today
    // document.getElementById('publicationDate').valueAsDate = new Date();
  },
  methods: {
    onSelected(product, value) {      
      if (value) {
        // push
        this.selectedProducts.push(product);
      } else {
        // splice
        this.selectedProducts = this.selectedProducts.filter(
          (p) => p.node.id !== product.node.id
        );
      }
    },
    updateSubsriptions() {
      // const selectedProducts = this.allProducts.filter(p => p.selected);
      const sumQty = this.selectedProducts.reduce(
        (acc, product) => acc + product.qty,
        0
      );
      console.log(sumQty);

      if (sumQty != this.plan.qty) {
        this.alert = `You have to select exactly ${this.plan.qty} product${
          this.plan.qty > 1 ? "s" : ""
        } for this subscription plan`;
        return;
      }

      if (!this.nextChargeDate) {
        this.alert = `You have to set next charge date`;
        return;
      }

      this.alert = "";

      this.$emit(
        "commit",
        this.selectedProducts.map((product) => ({
          title: _get(product, "node.title"),
          // and from 0th variant
          id: parseInt(
              _get(product, "node.variants.edges[0]node.id")
              .split("/")
              .pop()
          ),
          price: _get(product, "node.variants.edges[0]node.price.amount"),
          qty: product.qty,
        })),
        this.nextChargeDate
      );
    },
  },
};
</script>

<style scoped>
.warning {
  color: orange;
}
.publicationDate {
  margin-top: 2rem;
}
</style>